<template>

  <div class="person-box">
    <userInfoPanel class="user-top" @EMITUserInfoSetting="ActionUesrSetting"></userInfoPanel>
    <!-- <div @click="wxLogin" style="font-size：18px;margin:20px auto">登录哈哈哈哈哈哈哈</div> -->

    <!--我的订单-->
    <userCenterMenuPanel class="menuPanel" :hasMore="moreOrder" panelTitle="我的订单" panelTag="myOrder" :menuList="orderMenuList" @ActionMore="PanelActionMore" @ActionMenuItemClick="ActionMenuClick"></userCenterMenuPanel>

    <!--核心服务-->
    <userCenterMenuPanel class="menuPanel" panelTitle="核心服务" panelTag="coreService" :menuList="coreServicesList" @ActionMore="PanelActionMore" @ActionMenuItemClick="ActionMenuClick"></userCenterMenuPanel>

    <!--必须工具-->
    <userCenterMenuPanel class="menuPanel" panelTitle="必备工具" panelTag="neededTools" :menuList="appToolsList" @ActionMore="PanelActionMore" @ActionMenuItemClick="ActionMenuClick"></userCenterMenuPanel>

  </div>
</template>



<script>
import userCenterMenuPanel from "@/components/userCenterMenuPanel";
import userInfoPanel from "@/components/userInfoPanel";

import menuConfig from "../../config/userCenterMenus";
import { userIndex } from "@/api/index";
import { mapGetters } from "vuex";
export default {
  name: "personBase",
  components: {
    userInfoPanel, //用户信息
    userCenterMenuPanel, //菜单面板标题
  },
  data() {
    return {
      moreOrder: true,
      orderMenuList: menuConfig.myorders,
      appToolsList: menuConfig.appTools,
      coreServicesList: menuConfig.coreServices,
      isLogin: this.$store.state.base.userInfo == null ? false : true,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    userIndex().then((res) => {
      console.log(res);
      if (res.data.errno == 0) {
        console.log(this.orderMenuList);
        this.orderMenuList.forEach((item, index) => {
          if (index == 0) {
            item.num = res.data.data.order.unpaid;
          } else if (index == 1) {
            item.num = res.data.data.order.unship;
          } else if (index == 2) {
            item.num = res.data.data.order.unrecv;
          } else if (index == 3) {
            item.num = res.data.data.order.uncomment;
          }
        });
      }
      // "unrecv":0,//待收货
      //       "uncomment":0,//待评论
      //       "unpaid":3,//待付款
      //       "unship":0//待发货
    });
    if (
      this.$store.state.base.userInfo &&
      this.$store.state.base.userInfo.token != null
    ) {
      this.isLogin = true;
    }
  },
  methods: {
    //用户设置
    ActionUesrSetting(data) {
      console.log(data);
      //再此处push更多订单
      if (
        this.$store.state.base.userInfo != null &&
        sessionStorage.getItem("Token") != undefined
      ) {
        this.$router.push("/userSetting");
      } else {
        this.$router.push("/login");
      }
    },

    //菜单面板导航条右侧更多按钮
    PanelActionMore(data) {
      console.log(data);

      //再此处push更多订单
      if (this.$store.state.base.userInfo == null) {
        this.$router.push("/login");
        return;
      }
      this.$router.push("/myorders/0");
    },

    //菜单单击按钮，根据menuItem中的Tag属性分类处理
    ActionMenuClick(menuItem) {
      if (this.$store.state.base.userInfo == null) {
        this.$router.push("/login");
        return;
      }
      const itemTag = menuItem.tag;
      if (itemTag == "addressManagement") {
        this.$router.push("/addressManagement");
      } else if (itemTag == "mycoupon") {
        this.$router.push("/mycoupon");
      } else if (itemTag == "aboutus") {
        this.$router.push("/aboutus");
      } else if (itemTag == "phonebind") {
        this.$router.push("/phonebind");
      } else if (itemTag == "feedback") {
        this.$router.push("/feedback");
      } else if (itemTag == "orderMenu") {
        console.log(menuItem.index);
        //我的订单
        const orderIndex = menuItem.index; //订单类型
        if (orderIndex != 4) {
          this.$router.push("/myorders/" + orderIndex);
        } else {
          this.$router.push("myComments");
        }
      } else if (itemTag == "favourate") {
        //我的收藏
        this.$router.push("/favourate");
      } else {
        this.$router.push("/addressNew");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.person-box {
  // overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
  background: #f4f4f4;
  box-sizing: border-box;
  // margin-top: -60px;
  position: fixed;
  top: 0;
  width: 100%;

  .user-top {
    background: url("../../assets/index/preson_bg.png") top left no-repeat;
    background-size: 100%;
  }
}

.menuPanel {
  margin-top: 10px;
}
.person-box-nomargin {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/person/base.vue